interface IChannelHealthIconProps {
  className?: string;
}

/**
 * A speech bubble carrying a pulse line — whether our messages reach the
 * members they are sent to, read like a vital sign. The pulse keeps it apart
 * from the Assistant tile's bubble, which holds a memory node. Monoline, `currentColor`, no fills.
 * Sized on a 48×48 grid.
 */
const ChannelHealthIcon = ({ className }: IChannelHealthIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    {/* bubble */}
    <path d="M10 10 h28 a2 2 0 0 1 2 2 v18 a2 2 0 0 1 -2 2 H22 l-8 6 v-6 h-4 a2 2 0 0 1 -2 -2 V12 a2 2 0 0 1 2 -2 z" />
    {/* pulse */}
    <path d="M13 21 h6 l3 -6 l4 12 l3 -6 h6" />
  </svg>
);

export default ChannelHealthIcon;
